// components/LoadingSpinner.jsx
import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function LoadingSpinner({ size = 40, text = "Loading..." }) {
  return (
    <Box className="flex flex-col items-center justify-center p-4">
      <CircularProgress size={size} />
      {text && <p className="mt-2 text-gray-600 text-sm">{text}</p>}
    </Box>
  );
}
